import { CustomersApi } from '~/api';
import { action, makeObservable, observable, persist } from '~/modules';

export default class CustomersStore {
  @observable
  customersList: ListResponse<Customer> = {};

  @persist('object')
  @observable
  currentCustomer: Customer = {} as Customer;

  @observable
  customerAccounts: CustomerAccount[] = [];

  constructor() {
    makeObservable(this);
  }

  @action
  getCustomers = async (values: GetCustomersProps): Promise<void> => {
    this.customersList = await CustomersApi.getCustomers(values);
  };

  @action
  setCurrentCustomer = async (values: Customer): Promise<void> => {
    this.currentCustomer = values;
  };

  @action
  getCustomerById = async (customerId: string): Promise<void> => {
    this.currentCustomer = await CustomersApi.getCustomerById(customerId);
  };

  @action
  getCustomerAccounts = async (customerId: string): Promise<void> => {
    this.customerAccounts = await CustomersApi.getCustomerAccounts(customerId);
  };
}
